import { Injectable } from '@angular/core';
//import { Position } from 'perfect-scrollbar';
import {Observable} from 'rxjs';

@Injectable()
export class GeoLocationService {
    mLat:any;
    mLong:any;
  coordinates: any;
    //Position:any;
  constructor() { }

  public getPosition(): Observable<any> {
    return Observable.create(
        (observer) => {
        navigator.geolocation.watchPosition((pos) => {
          observer.next(pos);
        }),
        () => {
        },
        {
          enableHighAccuracy: true
        };
      });
    }
  }